/**
 * Короткая ссылка приглашения: `/r/CODE` (§40).
 *
 * Страница ничего не показывает — она запоминает код и уводит на регистрацию.
 * Вошедшего пользователя охранник роутов вернёт на главную: своим кодом
 * воспользоваться нельзя, но и ошибку показывать незачем.
 */
import { useEffect } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { saveReferralCode } from '../features/referral/storage';

export function ReferralLandingPage() {
  const { code = '' } = useParams();

  useEffect(() => {
    if (code) saveReferralCode(code);
  }, [code]);

  return <Navigate to="/register" replace />;
}
